export enum Mode {
  News = 'News',
  Announcement = 'Announcement',
}

export enum YesOrNo {
  Yes = 'Yes',
  No = 'No',
}
